import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=2b2e1fc0&scoped=true&"
import script from "./EventModal.vue?vue&type=script&lang=js&"
export * from "./EventModal.vue?vue&type=script&lang=js&"
import style0 from "./EventModal.vue?vue&type=style&index=0&id=2b2e1fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e1fc0",
  null
  
)

export default component.exports